module.exports = __webpack_public_path__ + "img/notify811_holyMoley_scaled.e81a3939.png";